<template>
	<div>
		<BaseAccordionController>
			<template v-slot:component>
				<v-container class="card-wrapper" grid-list-lg>
					<div class="form-area">
						<v-form ref="form" v-model="valid" class="form-color">
							<v-container>
								<v-text-field
									v-model="formdata.firstName"
									:label="
										getStateWithParam(
											'volunteering_form_firstname'
										)
									"
									outlined
									:rules="nameRules"
								></v-text-field>

								<v-text-field
									v-model="formdata.fathersName"
									:label="
										getStateWithParam(
											'volunteering_form_fathername'
										)
									"
									outlined
								></v-text-field>

								<v-text-field
									v-model="formdata.lastName"
									:rules="lastnameRules"
									:label="
										getStateWithParam(
											'volunteering_form_lastname'
										)
									"
									outlined
								></v-text-field>

								<v-text-field
									v-model="formdata.birthPlace"
									:label="
										getStateWithParam(
											'volunteering_form_birthPlace'
										)
									"
									outlined
								></v-text-field>

								<v-text-field
									v-model="formdata.address"
									:label="
										getStateWithParam(
											'volunteering_form_address'
										)
									"
									outlined
								></v-text-field>

								<v-text-field
									v-model="formdata.school"
									:label="
										getStateWithParam(
											'volunteering_form_school'
										)
									"
									outlined
								></v-text-field>

								<v-text-field
									v-model="formdata.workingInstitution"
									:label="
										getStateWithParam(
											'volunteering_form_work'
										)
									"
									outlined
								></v-text-field>

								<v-text-field
									v-model="formdata.email"
									:rules="emailRules"
									:label="
										getStateWithParam(
											'volunteering_form_email'
										)
									"
									outlined
								></v-text-field>
								<v-text-field
									v-model="formdata.phoneNumber"
									type="number"
									:label="
										getStateWithParam(
											'volunteering_form_number'
										)
									"
									outlined
								></v-text-field>

								<div>
									<v-menu
										ref="menu"
										v-model="menu"
										:close-on-content-click="false"
										transition="scale-transition"
										offset-y
										min-width="auto"
									>
										<template
											v-slot:activator="{ on, attrs }"
										>
											<v-text-field
												v-model="formdata.birthday"
												:label="
													getStateWithParam(
														'volunteering_form_birthday'
													)
												"
												append-icon="event"
												readonly
												v-bind="attrs"
												v-on="on"
												:rules="birthdayRules"
											></v-text-field>
										</template>
										<v-date-picker
											v-model="formdata.birthday"
											:active-picker.sync="activePicker"
										></v-date-picker>
										<v-spacer></v-spacer>
										<div
											class="footer-btn-white text-white"
										>
											<v-btn
												text
												color="primary"
												@click="menu = false"
											>
												Cancel
											</v-btn>
											<v-btn
												text
												color="primary"
												@click="$refs.menu.save()"
											>
												OK
											</v-btn>
										</div>
									</v-menu>
								</div>

								<v-select
									v-model="selectedVolunteeringTopics"
									:items="volunteeringTopics"
									item-text="name"
									item-value="id"
									multiple
									:label="
										getStateWithParam(
											'volunteering_form_commitment_name'
										)
									"
									required
									outlined="true"
									:rules="topicRules"
								></v-select>

								<v-select
									v-model="selectedPeriodOfInterestItems"
									:items="periodOfInterestItems"
									:label="
										getStateWithParam(
											'volunteering_form_period_of_interest'
										)
									"
									required
									outlined="true"
									:rules="poiRules"
								></v-select>
							</v-container>
						</v-form>

						<div class="submit">
							<v-btn
								depressed
								class="submit-button align-center"
								@click.native="submitForm()"
							>
								{{
									getStateWithParam(
										"volunteering_form_button"
									)
								}}
							</v-btn>
						</div>
					</div>

					<v-dialog
						v-if="codeOpen"
						v-model="submitted"
						@close="closeCodeVerificationDialog"
					>
						<v-card>
							<v-card-title class="text-h5 grey lighten-2">
								{{
									getStateWithParam(
										"volunteering_confirmation_title"
									)
								}}
							</v-card-title>

							<v-card-text>
								{{
									getStateWithParam(
										"volunteering_confirmation_text"
									)
								}}</v-card-text
							>

							<v-card-text class="email-code">{{
								formdata.email
							}}</v-card-text>

							<v-card-text class="email-code-resend">
								{{
									getStateWithParam(
										"volunteering_resend_code_text"
									)
								}}
							</v-card-text>

							<v-card-text class="email-code" @click="submitForm">
								{{
									getStateWithParam(
										"volunteering_resend_code_text"
									)
								}}
							</v-card-text>

							<div class="input-code">
								<input
									v-model="code"
									type="number"
									:placeholder="
										getStateWithParam(
											'volunteering_confirmation_label'
										)
									"
									required
									oninput="this.value = this.value.slice(0, 6)"
									@input="validateCode"
								/>
								<label v-if="codeError" class="error-label">{{
									codeError
								}}</label>
								<label v-if="kodigabim" class="error-label">{{
									kodigabimerror
								}}</label>
							</div>

							<v-divider></v-divider>

							<v-card-actions>
								<v-spacer></v-spacer>

								<v-btn
									class="back-button"
									color="primary"
									text
									@click="sendCode(formdata.email, code)"
								>
									{{
										getStateWithParam(
											"volunteering_confirmation_submit_button"
										)
									}}
								</v-btn>
							</v-card-actions>
						</v-card>
					</v-dialog>

					<v-dialog
						v-if="submitted && !applicationError && !codeOpen"
						v-model="submitted"
					>
						<v-card>
							<v-card-title class="text-h5 grey lighten-2">
								{{
									getStateWithParam(
										"volunteering_form_toast_success_title"
									)
								}}
							</v-card-title>

							<v-card-text>
								{{
									getStateWithParam(
										"volunteering_form_toast_success_text"
									)
								}}</v-card-text
							>

							<v-divider></v-divider>

							<v-card-actions>
								<v-spacer></v-spacer>
								<v-btn
									class="back-button"
									color="primary"
									text
									@click="submitted = false"
								>
									{{
										getStateWithParam(
											"volunteering_form_toast_back_button_all"
										)
									}}
								</v-btn>
							</v-card-actions>
						</v-card>
					</v-dialog>

					<v-dialog
						v-if="submitted && applicationError && !codeOpen"
						v-model="submitted"
					>
						<v-card>
							<v-card-title class="text-h5 grey lighten-2">
								{{
									getStateWithParam(
										"volunteering_form_toast_failed_title"
									)
								}}
							</v-card-title>

							<v-card-text>
								{{
									getStateWithParam(
										"volunteering_form_toast_failed_text"
									)
								}}
							</v-card-text>

							<v-divider></v-divider>

							<v-card-actions>
								<v-spacer></v-spacer>
								<v-btn
									class="back-button"
									color="primary"
									text
									@click="submitted = false"
								>
									{{
										getStateWithParam(
											"volunteering_form_toast_back_button"
										)
									}}
								</v-btn>
							</v-card-actions>
						</v-card>
					</v-dialog>
				</v-container>
			</template>
		</BaseAccordionController>
	</div>
</template>

<script>
import { VOLUNTEERING_TOPIC_URL } from "@/config/api/url/urls_in_app";
import native_capacitor from "@/config/js_helper/native_capacitor.js";
import {
	VOLUNTEERING_FORM_URL_TOPIC,
	VOLUNTEERING_FORM_URL_VERIFY,
} from "@/config/api/url/urls_in_app";
import {
	API_CLIENT_POST_FORM,
	API_CLIENT_GET,
} from "@/config/api/api_call/service_instances";
export default {
	name: "volunteeringAllForm",
	components: {},
	props: {
		// showformdialog: {
		// 	type: Boolean,
		// 	default: false,
		// },
		// volunteeringId: {
		// 	type: String,
		// 	default: null,
		// },
		// volunteeringName: {
		// 	type: String,
		// 	default: null,
		// },
		// volunteeringSubjects: {
		// 	type: Array,
		// 	default: null,
		// },
	},
	data() {
		return {
			selectedVolunteeringTopics: "",
			selectedPeriodOfInterestItems: "",
			volunteeringTopics: [],
			kodigabim: false,
			kodigabimerror: "",
			submitted: false,
			applicationError: false,
			codeOpen: false,
			code: "",
			codeError: "",
			formdata: {
				firstName: "",
				fathersName: "",
				lastName: "",
				birthPlace: "",
				address: "",
				school: "",
				workingInstitution: "",
				interests: [
					{
						id: "",
						periodOfInterest: "",
					},
				],

				email: "",
				phoneNumber: "",
				birthday: "",
				deviceId: "",
			},

			verificationFormdata: {
				deviceId: "",
				email: "",
				verificationCode: "",
			},

			menu: false,
			activePicker: null,

			dataloaded: false,

			valid: true,

			nameRules: [
				(v) =>
					!!v ||
					this.getStateWithParam("volunteering_form_name_rule"),
			],
			fatherRules: [
				(v) =>
					!!v ||
					this.getStateWithParam("volunteering_form_fathername_rule"),
			],
			lastnameRules: [
				(v) =>
					!!v ||
					this.getStateWithParam("volunteering_form_lastname_rule"),
			],
			birthPlaceRules: [
				(v) =>
					!!v ||
					this.getStateWithParam("volunteering_form_birthplace_rule"),
			],
			addressRules: [
				(v) =>
					!!v ||
					this.getStateWithParam("volunteering_form_address_rule"),
			],

			schoolRules: [
				(v) =>
					(!!v || !this.formdata.work) &&
					(!!v ||
						!!this.formdata.work ||
						this.getStateWithParam(
							"volunteering_form_school_rule"
						)),
			],

			workRules: [
				(v) =>
					!!v ||
					this.formdata.unemployed ||
					this.getStateWithParam("volunteering_form_work_rule"),
			],

			topicRules: [
				(v) =>
					!!v ||
					this.getStateWithParam("volunteering_form_topic_rule"),
			],

			poiRules: [
				(v) =>
					!!v ||
					this.getStateWithParam(
						"volunteering_form_period_of_interest_rule"
					),
			],

			// numberRules: [
			// 	(v) =>
			// 		!!v ||
			// 		this.getStateWithParam("volunteering_form_number_rule"),
			// ],

			birthdayRules: [
				(v) =>
					!!v ||
					this.getStateWithParam("volunteering_form_birthday_rule"),
			],

			emailRules: [
				(v) =>
					!!v ||
					this.getStateWithParam(
						"volunteering_form_required_email_rule"
					),
				(v) =>
					/.+@.+\..+/.test(v) ||
					this.getStateWithParam(
						"volunteering_form_valid_email_rule"
					),
			],
		};
	},
	created() {
		this.getTopics();
		native_capacitor.getPhoneId().then((userid) => {
			this.verificationFormdata.deviceId = userid.uuid;
			this.formdata.deviceId = userid.uuid;
		});
	},
	computed: {
		periodOfInterestItems() {
			const months = [1, 3, 6, 9, 12];
			return months.map((month) => ({
				text: `${month} ${this.getStateWithParam("month_select")}`,
				value: month,
			}));
		},
	},

	watch: {},
	menu(val) {
		val && setTimeout(() => (this.activePicker = "YEAR"));
	},
	methods: {
		getTopics() {
			//here we need to get the topics

			API_CLIENT_GET(VOLUNTEERING_TOPIC_URL)
				.then((response) => {
					this.volunteeringTopics = response.data;
					this.dataloaded = true;
					this.$store.state.active_loader = false;
				})
				.catch((err) => {
					this.errorloading = true;
					this.$store.state.active_loader = false;
				});
		},

		getStateWithParam(param) {
			return this.$store.getters.getLanguageParameters(param);
		},
		closeForm() {
			this.$router.back();
		},

		closeCodeVerificationDialog() {
			this.codeOpen = false;
		},

		submitForm() {
			console.log(this.$refs.form.validate());
			if (this.$refs.form.validate()) {
				let interests = [];

				// Populate interests array with objects containing id and periodOfInterest
				this.selectedVolunteeringTopics.forEach((id) => {
					interests.push({
						id: id,
						periodOfInterest: this.selectedPeriodOfInterestItems, // Initially set to null
					});
				});

				// Assign interests array to formdata
				this.formdata.interests = interests;

				console.log(this.formdata);

				this.$store.state.active_loader = true;

				API_CLIENT_POST_FORM(VOLUNTEERING_FORM_URL_TOPIC, this.formdata)
					.then((response) => {
						// Set codeOpen to true to open the code verification window
						this.codeOpen = true;
						this.submitted = true;
						this.applicationError = false;
						// Add the application to the store
						this.$store.dispatch(
							"addUnconfirmedApplication",
							this.formdata
						);
						this.$store.state.active_loader = false;
					})
					.catch((err) => {
						console.log(err);
						this.submitted = true;
						this.applicationError = true;
						this.$store.state.active_loader = false;
					});
			}
		},

		validateCode() {
			if (this.code.length === 6) {
				this.codeError = "";
			} else {
				this.codeError = this.getStateWithParam(
					"volunteering_form_valid_code_rule"
				);
			}
		},

		deleteApplication() {
			this.$store.dispatch(
				"removeUnconfirmedApplication",
				this.formdata.email
			);
		},

		sendCode(email, code) {
			if (this.code.length === 6) {
				// Perform your logic here
				this.verificationFormdata.email = email;
				this.verificationFormdata.verificationCode = code;

				this.$store.state.active_loader = true;

				API_CLIENT_POST_FORM(
					VOLUNTEERING_FORM_URL_VERIFY,
					this.verificationFormdata
				)
					.then((response) => {
						console.log(response);
						this.deleteApplication();
						this.codeOpen = false;
						this.submitted = true;
						this.applicationError = false;
						this.$store.state.active_loader = false;
					})
					.catch((err) => {
						this.$store.state.active_loader = false;
						console.log(err);

						this.submitted = true;
						this.applicationError = true;
						this.kodigabim = true;
						this.kodigabimerror = this.getStateWithParam(
							"volunteering_form_valid_code_not_confirmed"
						);
					});

				console.log(this.verificationFormdata);
			} else {
				this.codeError = this.getStateWithParam(
					"volunteering_form_valid_code_rule"
				);
			}
		},
	},
};
</script>

<style scoped>
.form-header {
	width: 100%;
	background-color: #e60000;
	color: #ffffff;
	font-size: 20px;
}

.email-code {
	font-size: 16px;
}

.email-code-resend {
	font-size: 16px;
	color: rgb(190, 0, 0);
}
.input-code input {
	font-size: 16px;
	padding: 10px;
	border: 1px solid #ccc;
	border-radius: 3px;

	box-sizing: border-box;
	margin: 16px 156px 16px 16px;
}

.input-code input::placeholder {
	letter-spacing: normal; /* Reset letter spacing for placeholder */
}

.input-code input[type="number"] {
	letter-spacing: 10px; /* Adjust letter spacing for entered digits */
}
.error-label {
	color: rgb(190, 0, 0);
	margin: 16px;
}

.submit {
	float: right;
	margin-top: 10px;
	margin-right: 6px;
}
.submit-button {
	background-color: #e60000 !important;
	color: #ffffff !important;
	margin-bottom: 25px !important;
}

.form-area {
	margin-top: -44px !important;
}

.back-button {
	margin-right: 16px;
	color: #ffffff !important;
}

/* .details-close-btn {
	position: absolute;
	top: 0;
	left: 0;
} */
</style>

<style>
#app
	> div.v-menu__content.theme--light.menuable__content__active
	> div.footer-btn-white.text-white {
	background-color: rgb(255, 255, 255) !important;
}
</style>
